<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Training and Placement Cell and III cell</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      

<section class="section-lg std-scholarship">
    <div class="container">
        <div class="table-responsive" >
            <table class="table table-bordered text-center tbl_custom">
				<thead>
					<tr>
						<th>Sr. No.</th>
						<th>Name</th>
						<th>Designation</th>
						
					</tr>
				</thead>
				<tbody>
					
					<tr>
						<td>1</td>
						<td>Dr. Jyoti Pillay</td>
						<td>Placement Co-ordinator</td>
					</tr>
					<tr>
						<td>2</td>
						<td>CA Manish Shah</td>
						<td>Member (Teaching)</td>
					</tr>
					<!-- <tr>
						<td>3</td>
						<td>Ms Priyanka Malkan</td>
						<td>Member (Teaching)</td>
					</tr>
					<tr>
						<td>4</td>
						<td>Mr. Aryan Dhuavia</td>
						<td>Member (Student)</td>
					</tr>
					<tr>
						<td>5</td>
						<td>Mr. Tanishq Chajjer</td>
						<td>Member (Student)</td>
					</tr> -->
				</tbody>
			</table>
        </div>
    </div>
</section>
